// store.js
import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query'
import { registryDocumentApi } from './registrydocumentapi';
import { registryPlatformProjectsApi } from './registryplatformprojectsapi';

const store = configureStore({
  reducer: {
    [registryDocumentApi.reducerPath] : registryDocumentApi.reducer,
    [registryPlatformProjectsApi.reducerPath]: registryPlatformProjectsApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
  getDefaultMiddleware().concat(
    registryDocumentApi.middleware,
    registryPlatformProjectsApi.middleware,
    ),
});

setupListeners(store.dispatch)

export default store
